angular.module('unica_event.event_controllers')

.controller('EventDetailController', function(
	$rootScope, $stateParams, $scope,
	$confirm,
	InvitationListListService, EventSendService,
	EventListService
) {

	$rootScope.resetEventData();
	$rootScope.getEvent( $stateParams.id );

	$scope.eventPreviewUrl = null;

	EventListService
		.getPreviewUrl( $stateParams.id )
		.then( function(url) {
			$scope.eventPreviewUrl = url;
		})


	$scope.sendSurveyNotification = function()
	{
		$confirm({
			title: 'Sei sicuro di voler procedere con l\'invio della notifica survey?',
			text: 'Confermi l\'invio della notifica survey (' + $rootScope.eventData.notification_type + ') a tutti i partecipanti?'
		}).then(function() {

			// if ( $rootScope.eventData.survey_sent_date ) {

				// $confirm({
				// 	title: 'Inviare una nuova notifica survey?',
				// 	text: 'Questa notifica era già stata inviata. Proseguire ed inviare di nuovo a tutti i partecipanti?'
				// }).then(function() {
				//
				// 	doSendSurvey();
				//
				// }, function() {});

			// } else {
				doSendSurvey();
			// }


		}, function() {
			// Cancel
		});
	};


	function doSendSurvey() {

		$scope.showLoader();
		EventSendService
			.sendSurvey( $stateParams.id )
			.then(function(data) {
				$scope.hideLoader();

				// I non raggiungibili sono quelli che non hanno numero impostato o non hanno l'app
				$scope.showSuccessMsg(
					'Invio di ' + data.notifiche +  ' notifiche ' + data.type + ' avviato con successo!' +
					' (' + data.not_defined + ' non raggiungibili)', ''
				);
				// }

			});
	}

});